import { cn } from "@repo/utils";
import type { DialogBaseProps } from "../dialog.types.js";

export const DialogDescription = ({ className, children }: DialogBaseProps) => {
  return <p className={cn("text-sm text-gray-500", className)}>{children}</p>;
};
